<h1 fxLayoutAlign="center">Why Top Crew ?</h1>
<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around">
	<div fxFlex="60">
		<p>We are not businessman, we are a team of PILOTS in Airlines & Flying Club in India as well as Abroad. We all have been
			through all hurdles of aviation. We invested almost double the resources because of improper guidance.</p>
		<p>We are here to help you by reducing cost,improving training standards and most important to SAVE YOUR TIME because Time
			is Money.</p>
	</div>
</div>
<h1 fxLayoutAlign="center">Our Team</h1>

<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around">
	<div fxFlex="30">
		<mat-card>
			<img width="50%" fxLayoutAlign="center" style="border-radius:200px; margin:0 auto;"  src="https://firebasestorage.googleapis.com/v0/b/top-crew.appspot.com/o/TCA-ASSETS%2Fp.webp?alt=media&token=1748cab4-caf0-4959-9890-e20e96ba57df" alt="">
			<mat-card-title>
				<h3> Capt P Kumar</h3>
			</mat-card-title>
			<mat-card-content>
			  <p>He started in field of aviation in 2007. With over 10 years experience he has guided number of students to
            fulfill their dream. He's been training students in RTR(A) for many years now.</p>
			</mat-card-content>
		</mat-card>
	</div>

  <div fxFlex="30">
		<mat-card>
			<img width="50%" fxLayoutAlign="center" style="border-radius:200px; margin:0 auto;" src="https://firebasestorage.googleapis.com/v0/b/top-crew.appspot.com/o/TCA-ASSETS%2Ft.webp?alt=media&token=fea9ced9-6f7a-4397-8363-6a9815880c89" alt="">
			<mat-card-title>
			<h3>Capt Tarun B</h3>
			</mat-card-title>
			<mat-card-content>
			 <p>He started his career in aviation in year 2008. Since last 7 years he's been training young aviators. He's
            been helping students with his free blog <a href="https://av8n.in">Av8n.in</a> and free app <a
              href="https://play.google.com/store/apps/details?id=com.av8n.tb">DGCA ATPL CPL Thoery</a> </p>
			</mat-card-content>
		</mat-card>
	</div>
</div>